import React from "react";
import "./CreationFailuresAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";
import { CreationFailuresTable } from "../../SuperChatAIOrderTable/CreationFailuresTable";

export const CreationFailuresAICard = ({
  message,
  title,
  onClientClick,
}) => {
  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <div className="creation-failures-ai-card ai-left">
      <div className="creation-failures-ai-header">
        <img src={aiChatlogo} alt="Axon AI" className="creation-failures-ai-logo" />
        <div className="creation-failures-ai-title">
          <span>{title || "Axon AI"}</span>
          <div className="creation-failures-time">{`${day} ${time}`}</div>
        </div>
      </div>
      <div className="creation-failures-ai-bubble-inner">
        {message.text}
        {message.creationFailures && (
          <CreationFailuresTable
            failures={message.creationFailures}
            message={message}
            onClientClick={onClientClick}
          />
        )}
      </div>
    </div>
  );
};
